import { Link } from 'react-router-dom'
import styles from './sidebar.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { Tooltip, Typography } from '@mui/material'
import { disconnectSocket, logout } from '../../features/authSlice'
import { toggleSidebar } from '../../features/sidebarSlice'
import { NavItem } from './NavItem'

const ADMIN_ROUTES = [
	{
		id: 'dashboard',
		icon: '/images/home-2.svg',
		label: 'Dashboard',
		to: '/admin',
		dataCy: 'admin-dashboard',
	},
	{
		id: 'configs',
		icon: '/images/setting-icon.svg',
		label: 'Configs',
		to: '/admin/configs',
		dataCy: 'admin-configs',
		matchPrefix: true,
	},
]

export const AdminSideNavbar = () => {
	const dispatch = useDispatch()
	const isSidebarOpen = useSelector((state) => state.sidebar.isSidebarOpen)

	const handleLogout = async () => {
		dispatch(disconnectSocket())
		dispatch(logout())
	}

	const handleSidebarExpand = () => {
		dispatch(toggleSidebar())
	}

	return (
		<>
			<div className={`${styles.SideNavbar} SideNavbar`}>
				<div className={styles.sideTop}>
					{isSidebarOpen ? (
						<Link to="/admin" className={styles.sidebarLogoFull}>
							<img
								src="/images/ontimebridelogo.svg"
								alt="Wedding Planner Logo"
							/>
						</Link>
					) : (
						<Link to="/admin" className={styles.sidebarLogo}>
							<img
								src="/images/sidebarLogo.svg"
								alt="Wedding Planner Logo"
							/>
						</Link>
					)}

					<ul className={styles.topNav} aria-label="Admin navigation">
						{ADMIN_ROUTES.map((route) => (
							<NavItem
								key={route.id}
								icon={route.icon}
								label={route.label}
								to={route.to}
								dataTestId={route.dataCy}
								isSidebarOpen={isSidebarOpen}
								matchPrefix={route.matchPrefix}
							/>
						))}
					</ul>
				</div>
				<ul className={styles.bottomNav}>
					<li data-cy="logout">
						<Tooltip
							title="Log Out"
							placement="right"
							disableInteractive
							arrow
						>
							<button
								type="button"
								onClick={handleLogout}
								className={styles.logoutButton}
							>
								<img
									src="/images/logout-icon.svg"
									alt="Log out"
								/>
								{isSidebarOpen && (
									<Typography
										variant="body1"
										className={`${styles.linkText} linkText`}
									>
										logout
									</Typography>
								)}
							</button>
						</Tooltip>
					</li>
				</ul>
			</div>
			<div className="overlay" onClick={handleSidebarExpand}></div>
		</>
	)
}
